import { useState } from "react";
import { FileText, Download } from "lucide-react";

export default function Facture() {
  const [numero, setNumero] = useState("");

  const open = (type) => (e) => {
    e.preventDefault();
    if (!numero.trim()) return;
    window.open(
      `${process.env.REACT_APP_BACKEND_URL}/api/facture-${type}/${numero.trim().toUpperCase()}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="min-h-screen bg-[#141414] px-6 py-20" data-testid="facture-page">
      <div className="mx-auto max-w-2xl">
        <a href="/" data-testid="facture-back-link" className="text-xs uppercase tracking-[0.3em] text-white/40 transition-colors hover:text-gold">
          ← Retour au site
        </a>
        <h1 className="mt-8 font-display text-4xl tracking-tight text-white sm:text-5xl">
          Générer une <em className="italic text-gold">facture</em>
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-white/50">
          Saisissez le numéro du devis (ex. DEV-2026-0003) puis choisissez la facture :
          <strong className="text-white/70"> acompte de 60 %</strong> après réception de l'acompte, ou{" "}
          <strong className="text-white/70">solde de 40 %</strong> avant l'événement.
          Chaque facture est calculée automatiquement, avec cachet et signature, prête à envoyer au client.
        </p>
        <form onSubmit={open("acompte")} className="mt-12 space-y-8 rounded-3xl border border-white/10 bg-[#0a0a0a]/60 p-8 backdrop-blur-xl lg:p-10" data-testid="facture-form">
          <div>
            <label className="mb-2 block text-[10px] font-semibold uppercase tracking-[0.3em] text-white/40">
              Numéro du devis
            </label>
            <input
              type="text"
              value={numero}
              onChange={(e) => setNumero(e.target.value)}
              required
              placeholder="DEV-2026-0003"
              data-testid="facture-input-numero"
              className="w-full border-b border-white/20 bg-transparent py-4 font-display text-2xl text-white placeholder-white/25 outline-none transition-colors duration-300 focus:border-gold"
            />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <button
              type="submit"
              data-testid="facture-acompte-button"
              className="group flex items-center justify-center gap-3 rounded-full bg-gold py-5 text-xs font-bold uppercase tracking-[0.2em] text-[#0a0a0a] transition-transform duration-300 hover:scale-[1.02]"
            >
              <FileText className="h-4 w-4" />
              Acompte 60 %
              <Download className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            </button>
            <button
              type="button"
              onClick={open("solde")}
              data-testid="facture-solde-button"
              className="group flex items-center justify-center gap-3 rounded-full border border-gold/60 py-5 text-xs font-bold uppercase tracking-[0.2em] text-gold transition-colors duration-300 hover:bg-gold hover:text-[#0a0a0a]"
            >
              <FileText className="h-4 w-4" />
              Solde 40 %
              <Download className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            </button>
          </div>
        </form>
        <p className="mt-6 text-center text-xs text-white/30">
          Les montants sont calculés automatiquement à partir du devis : 60 % d'acompte, 40 % de solde.
        </p>
      </div>
    </div>
  );
}
